import { getAPI } from '@/utils/api'
import { getLocal, setLocal } from '@/utils/globalState'
const defaultSetting = {
  rows: [
    { title: '製作中', code: '1', class: 'gray-block' },
    { title: '請取餐', code: '2', class: 'green-block' }
  ],
  storeName: '', // 店名
  marqueeText: ['跑馬燈資訊', '跑馬燈資訊2'],
  bgClass: 'gray',
  storeList: [],
  siteConfig: {}
}
const app = {
  namespace: true,
  state: {
    sidebar: {
      // opened: !+getLocal('sideBarStatus')
      opened: getLocal('sideBarStatus')
    },
    language: getLocal('language', null, 'zh'), // 預設中文
    stageData: '', // 儲存主機資訊
    apiData: '', // 儲存api設定資料
    menuData: '', // 儲存
    siteData: '', // 儲存site設定
    env: '', // 目前環境設定
    setting: getLocal('setting', 'local', defaultSetting),
    siteConfig: ''
  },
  mutations: {
    TOGGLE_SIDEBAR: state => {
      if (state.sidebar.opened) {
        setLocal('sideBarStatus', 1)
      } else {
        setLocal('sideBarStatus', 0)
      }
      state.sidebar.opened = !state.sidebar.opened
    },
    SET_LANGUAGE: (state, language) => {
      state.language = language
      setLocal('language', language)
    },
    SET_APIDATA: (state, apiData) => {
      state.apiData = apiData
    },
    SET_STAGEDATA: (state, stageData) => {
      state.stageData = stageData
    },
    SET_MENUDATA: (state, menuData) => {
      state.menuData = menuData
    },
    SET_ENV: (state, envData) => {
      state.env = envData
    },
    SET_SETTING: (state, setting) => {
      state.setting = setting
      setLocal('setting', setting, 'local') // 寫在本機
    },
    SET_STORELIST: (state, storeList) => {
      state.storeList = storeList
    },
    SET_SITEDATA: (state, siteData) => {
      state.siteData = siteData
    },
    SET_SITECONFIG: (state, siteConfig) => {
      state.siteConfig = siteConfig
    }
  },
  actions: {
    ToggleSideBar: ({ commit }) => {
      commit('TOGGLE_SIDEBAR')
    },
    SetLanguage ({ commit }, language) {
      commit('SET_LANGUAGE', language)
    },
    SetAPIData ({ commit }, data) {
      commit('SET_APIDATA', data)
    },
    SetStageData ({ commit }, data) {
      commit('SET_STAGEDATA', data)
    },
    SetMenuData ({ commit }, data) {
      commit('SET_MENUDATA', data)
    },
    SetSiteData ({ commit }, data) {
      commit('SET_SITEDATA', data)
    },
    SetEnv ({ commit }, data) {
      commit('SET_ENV', data)
    },
    SetSetting ({ commit }, data) {
      commit('SET_SETTING', data)
    },
    // 取得店家資訊
    GetStoreList ({ commit }, site) {
      const api = getAPI()
      return new Promise((resolve, reject) => {
        api.storeList(site).then(response => {
          if (response.data.length > 0) {
            commit('SET_STORELIST', response.data)
            resolve(response)
          } else {
            console.log(`store list is empty!!`)
            // 當取不到店家資料 可能帳號不對要清空local
            resolve(response)
            // reject(new Error('storeList empty'))
          }
        }).catch(e => {
          console.log('GetStoreList error==')
          console.log(e)
          reject(e)
        })
      })
    },
    // 取得site Config
    GetSiteConfig ({ commit }, site) {
      const api = getAPI()
      return new Promise((resolve, reject) => {
        api.getSiteConfig(site).then(response => {
          console.log('get site config===')
          console.log(response)
          commit('SET_SITECONFIG', response.data)
          resolve(response)
        }).catch(e => {
          console.log('GetSiteConfig error==')
          console.log(e)
          reject(e)
        })
      })
    }
  }
}
export default app
